export default __webpack_public_path__ + "static/media/1_0000.3aca9fcc.webp";